import { useState, useEffect } from 'react';
import { useInstallPrompt } from '../../hooks/useInstallPrompt';
import './InstallPrompt.css';

const InstallPrompt = () => {
  const { canInstall, isIOS, isInstalled, install } = useInstallPrompt();
  const [dismissed, setDismissed] = useState(false);
  const [showBanner, setShowBanner] = useState(false);

  // Check localStorage for dismissal preference
  useEffect(() => {
    const isDismissed = localStorage.getItem('pwa-install-dismissed');
    if (isDismissed) {
      setDismissed(true);
    }
  }, []);

  // Show banner if appropriate
  useEffect(() => {
    if (isInstalled || dismissed) {
      setShowBanner(false);
      return;
    }

    // Show on iOS (no native prompt available)
    if (isIOS) {
      setShowBanner(true);
      return;
    }

    if (canInstall) {
      setShowBanner(true);
      return;
    }

    setShowBanner(false);
  }, [isIOS, canInstall, isInstalled, dismissed]);

  const handleInstall = async () => {
    if (canInstall) {
      await install();
      setShowBanner(false);
    }
  };

  const handleDismiss = () => {
    setDismissed(true);
    localStorage.setItem('pwa-install-dismissed', 'true');
    setShowBanner(false);
  };

  const handleUndo = () => {
    localStorage.removeItem('pwa-install-dismissed');
    setDismissed(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="install-prompt-banner">
      <div className="install-prompt-content">
        <div className="install-prompt-text">
          {canInstall && (
            <>
              <h3 className="install-prompt-title">Install MathDingo</h3>
              <p className="install-prompt-description">
                Add MathDingo to your home screen for a better UI experience.
              </p>
            </>
          )}
          {isIOS && (
            <>
              <h3 className="install-prompt-title">Add to Home Screen</h3>
              <p className="install-prompt-description">
                Tap <span className="install-prompt-icon">⬆️</span> and select "Add to Home Screen" for full-screen access.
              </p>
            </>
          )}
        </div>

        <div className="install-prompt-actions">
          {canInstall && (
            <button 
              className="install-prompt-btn install-btn"
              onClick={handleInstall}
              aria-label="Install MathDingo"
            >
              Install
            </button>
          )}
          <button 
            className="install-prompt-btn dismiss-btn"
            onClick={handleDismiss}
            aria-label="Dismiss install prompt"
          >
            {canInstall ? 'Not now' : 'Dismiss'}
          </button>
        </div>
      </div>

      {dismissed && (
        <button 
          className="install-prompt-undo"
          onClick={handleUndo}
          title="Undo dismissal"
        >
          ↩️
        </button>
      )}
    </div>
  );
};

export default InstallPrompt;
